/**
 * Gender Enum
 *
 * Values synced with backend GenderEnum.
 * @see backend/src/backend/db/constants/gender.py
 *
 * Backend values:
 * - M = "M" (Male)
 * - F = "F" (Female)
 */
import { intl } from "dmsbasereact";


export const GENDER_VALUES = {
    MALE: "M",
    FEMALE: "F",
};

/**
 * Factory for translated Gender enum
 * Translation is resolved at runtime
 */
export const getGenderEnum = () => ({
    [GENDER_VALUES.MALE]: {
        value: GENDER_VALUES.MALE,
        label: intl.get("Male").d("Male"),
    },
    [GENDER_VALUES.FEMALE]: {
        value: GENDER_VALUES.FEMALE,
        label: intl.get("Female").d("Female"),
    },
});

/**
 * Get gender label from value
 * @param {string} value - Gender value ("M" or "F")
 * @returns {string} Gender label or value if not found
 */
export const getGenderLabel = (value) => {
    const genderEnum = getGenderEnum();
    return genderEnum[value]?.label || value;
};

/**
 * Get gender options for select components
 * @returns {Array<{value: string, label: string}>}
 */
export const getGenderOptions = () => {
    const genderEnum = getGenderEnum();

    return Object.values(genderEnum).map(g => ({
        value: g.value,
        label: g.label,
    }));
};
